import { Component } from "react";
// import Checkbox from "components/common/controls/Checkbox"; // for future use.
import UserAuthenticationLayout from "./UserAuthenticationLayout";
import { connect } from "react-redux";
import {
  requestForUserSignUpAsync,
  signUpValidationRequestAsync,
  signUpEmailVerificationCodeRequtestAsync,
  signUpPhoneVerificationCodeRequtestAsync,
  setPostSignUpAuthenticationResponseAsync,
} from "store/slices/SignUpSlice";
import {
  getSubscription,
} from "store/slices/SubscriptionSlice";
import { requestToVerifyVerificationCodeAsync } from "apis/VerificationCodeApi";
import { unwrapResult } from "@reduxjs/toolkit";
import { withRouter } from "react-router-dom";
import { AppDispatch } from "store/store";
import { History } from "history";
import Loader from "components/common/controls/Loader";
import SignUpForm, { SignUpFormData } from "./SignUpForm";
import VerificationCodeProvider from "fetaures/verification/VerificationCodeProvider";
import VerificationResponse from "interfaces/response/VerificationResponse";
import { SignInSignUpOption } from "shared/enums/SignInSignUpOptionEnum";
import PromineoStepWizard from "components/common/PromineoStepWizard";
import SignUpValidationRequest from "interfaces/request/SignUpValidationRequest";
import SignUpEmailVerificationCodeRequest from "interfaces/request/SignUpEmailVerificationCodeRequest";
import VerifyCodeRequest from "interfaces/request/VerifyCodeRequest";
import SignUpRequest from "interfaces/request/SignUpRequest";
import AuthResponse from "interfaces/response/AuthResponse";
import SignUpPhoneVerificationCodeRequest from "interfaces/request/SignUpPhoneVerificationCodeRequest";
import SignUpSuccess from "./SignUpSuccess";
import * as routePath from "shared/constants/RoutePathConstants";

enum Steps {
  SIGNUP_FORM = 1,
  EMAIL_VERIFICATION_CODE_FORM = 2,
  PHONE_VERIFICATION_CODE_FORM = 3,
  SIGNUP_SUCCESS_MESSAGE = 4,
}

interface Props {
  dispatch: AppDispatch;
  history: History;
}

interface State {
  isLoading: boolean;
  signUpFormData: SignUpFormData;
  emailVerificationCodeResponse: VerificationResponse;
  phoneVerificationCodeResponse: VerificationResponse;
  stepWizard?: any;
  authenticationResponse?: AuthResponse;
}

export class SignUp extends Component<Props, State> {
  state: Readonly<State> = {
    isLoading: false,
    signUpFormData: {
      email: "",
      firstName: "",
      lastName: "",
      company: "",
      phone: "",
      phoneCode: "",
    },
    emailVerificationCodeResponse: {
      receiverAddress: "",
      expiryTime: "",
      token: "",
      code: "",
    },
    phoneVerificationCodeResponse: {
      receiverAddress: "",
      expiryTime: "",
      token: "",
      code: "",
    },
  };

  setLoadingState = (isLoading: boolean) => {
    this.setState({ isLoading: isLoading });
  };

  setStepWizardInstance = (instance: any) => {
    this.setState({
      stepWizard: instance,
    });
  };

  goToStep = (step: Steps) => {
    this.state.stepWizard?.goToStep(step);
  };

  goToSignUpStep = () => {
    this.state.stepWizard?.goToStep(Steps.SIGNUP_FORM);
  };

  getFullPhoneNumberFromFormData = () => {
    return `${this.state.signUpFormData.phoneCode}${this.state.signUpFormData.phone}`;
  };

  handleSignUpFormSubmit = (signUpFormData: SignUpFormData) => {
    const signUpValidationRequest: SignUpValidationRequest = {
      email: signUpFormData.email,
      phone: signUpFormData.phone,
      phoneCode: signUpFormData.phoneCode,
    };

    this.setLoadingState(true);
    this.props
      .dispatch(signUpValidationRequestAsync(signUpValidationRequest))
      .then(unwrapResult)
      .then(() => {
        this.setState(
          {
            signUpFormData: signUpFormData,
          },
          () => {
            this.requestForEmailVerificationCode();
          }
        );
      })
      .catch(() => {
        this.setLoadingState(false);
      });
  };

  requestForEmailVerificationCode = () => {
    const emailVerificationRequest: SignUpEmailVerificationCodeRequest = {
      email: this.state.signUpFormData.email,
    };

    this.props
      .dispatch(
        signUpEmailVerificationCodeRequtestAsync(emailVerificationRequest)
      )
      .then(unwrapResult)
      .then((emailVerificationResponse: VerificationResponse) => {
        this.setState(
          {
            
            emailVerificationCodeResponse: emailVerificationResponse,
          },
          () => {
            this.goToStep(Steps.EMAIL_VERIFICATION_CODE_FORM);
          }
        );
      })
      .finally(() => {
        this.setLoadingState(false);
      });
  };

  handleEmailVerificationCodeSubmit = (code: string) => {
    this.setLoadingState(true);
    const emailVerificationCodeVerifyRequest: VerifyCodeRequest = {
      code: code,
      token: this.state.emailVerificationCodeResponse.token,
      type: SignInSignUpOption.Email,
      identifier: this.state.signUpFormData.email,
    };

    requestToVerifyVerificationCodeAsync(emailVerificationCodeVerifyRequest)
      .then(() => {
        const updatedEmailVerificationState = {
          ...this.state.emailVerificationCodeResponse,
          code: code,
        };

        this.setState({
          emailVerificationCodeResponse: updatedEmailVerificationState,
        });

        this.requestForPhoneVerificationCode();
      })
      .catch(() => {
        this.setLoadingState(false);
      });
  };

  requestForPhoneVerificationCode = () => {
    const phoneVerificationRequest: SignUpPhoneVerificationCodeRequest = {
      phone: this.state.signUpFormData.phone,
      phoneCode: this.state.signUpFormData.phoneCode,
    };

    this.props
      .dispatch(
        signUpPhoneVerificationCodeRequtestAsync(phoneVerificationRequest)
      )
      .then(unwrapResult)
      .then((phoneVerificationResponse: VerificationResponse) => {
        this.setState(
          {
            phoneVerificationCodeResponse: phoneVerificationResponse,
          },
          () => {
            this.goToStep(Steps.PHONE_VERIFICATION_CODE_FORM);
          }
        );
      })
      .finally(() => {
        this.setLoadingState(false);
      });
  };

  handlePhoneVerificationCodeSubmit = (code: string) => {
    this.setLoadingState(true);
    const phoneVerificationCodeVerifyRequest: VerifyCodeRequest = {
      code: code,
      token: this.state.phoneVerificationCodeResponse.token,
      type: SignInSignUpOption.Phone,
      identifier: this.getFullPhoneNumberFromFormData(),
    };

    requestToVerifyVerificationCodeAsync(phoneVerificationCodeVerifyRequest)
      .then(() => {
        const updatedPhoneVerificationState = {
          ...this.state.phoneVerificationCodeResponse,
          code: code,
        };

        this.setState(
          {
            phoneVerificationCodeResponse: updatedPhoneVerificationState,
          },
          () => {
            this.requestForUserSignUp();
          }
        );
      })
      .catch(() => {
        this.setLoadingState(false);
      });
  };

  requestForUserSignUp = () => {
    const userSignUpRequest: SignUpRequest = {
      firstName: this.state.signUpFormData.firstName,
      lastName: this.state.signUpFormData.lastName,
      companyName: this.state.signUpFormData.company,
      emailData: {
        email: this.state.signUpFormData.email,
        code: this.state.emailVerificationCodeResponse.code,
        token: this.state.emailVerificationCodeResponse.token,
      },
      phoneData: {
        phone: this.state.signUpFormData.phone,
        phoneCode: this.state.signUpFormData.phoneCode,
        code: this.state.phoneVerificationCodeResponse.code,
        token: this.state.phoneVerificationCodeResponse.token,
      },
    };

    this.props
      .dispatch(requestForUserSignUpAsync(userSignUpRequest))
      .then(unwrapResult)
      .then((response: AuthResponse) => {
        this.setState({
          authenticationResponse: response,
        });
        this.goToStep(Steps.SIGNUP_SUCCESS_MESSAGE);
      })
      .finally(() => {
        this.setLoadingState(false);
      });
  };

  handleContinueToDashboardClick = () => {
    if (this.state.authenticationResponse) {
      this.setLoadingState(true);
      this.props
        .dispatch(
          setPostSignUpAuthenticationResponseAsync(
            this.state.authenticationResponse
          )
        )
        .then(() => {
          if (this.state.authenticationResponse?.subscriptionId) {
            this.props.dispatch(getSubscription(this.state.authenticationResponse.subscriptionId)).finally(() => {
              this.setLoadingState(false);
            });
          }
          else {
            this.props.history.push(routePath.SUBSCRIPTION);
            this.setLoadingState(false);
          }
        })
        .catch(() => {
          this.setLoadingState(false);
        });
    }
  };

  EmailVerificationCodeProvider = () => {
    return (
      <VerificationCodeProvider
        codeSendingAddress={this.state.signUpFormData.email}
        expireTime={this.state.emailVerificationCodeResponse.expiryTime}
        token={this.state.emailVerificationCodeResponse.token}
        authenticationType={SignInSignUpOption.Email}
        backLinkText="back to sign up"
        onBackLinkClick={this.goToSignUpStep}
        onVerificationCodeInputComplete={this.handleEmailVerificationCodeSubmit}
      />
    );
  };

  PhoneVerificationCodeProvider = () => {
    return (
      <VerificationCodeProvider
        codeSendingAddress={this.getFullPhoneNumberFromFormData()}
        expireTime={this.state.phoneVerificationCodeResponse.expiryTime}
        token={this.state.phoneVerificationCodeResponse.token}
        authenticationType={SignInSignUpOption.Phone}
        backLinkText="back to sign up"
        onBackLinkClick={this.goToSignUpStep}
        onVerificationCodeInputComplete={this.handlePhoneVerificationCodeSubmit}
      />
    );
  };

  render() {
    return (
      <>
        <UserAuthenticationLayout description="Sign up to access your free 5000 API transactions and start creating hassle free s-curves in powerBI.">
          <PromineoStepWizard
            initialStep={Steps.SIGNUP_FORM}
            instance={this.setStepWizardInstance}
          >
            <SignUpForm onSubmit={this.handleSignUpFormSubmit} />
            <this.EmailVerificationCodeProvider />
            <this.PhoneVerificationCodeProvider />
            <SignUpSuccess
              onContinueClick={this.handleContinueToDashboardClick}
            />
          </PromineoStepWizard>
        </UserAuthenticationLayout>
        <Loader isVisible={this.state.isLoading} />
      </>
    );
  }
}

export default withRouter(connect()(SignUp));
